import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import { omit } from 'lodash';

export const useQueryParams = <T extends object>() => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = (queryString.parse(location.search) ?? {}) as T;
  const setQueryParams = (newParams: Record<string, unknown>) => {
    const searchQuery = queryString.stringify(newParams, {
      skipEmptyString: true,
      skipNull: true,
    });
    history.replace(`${location.pathname}?${searchQuery}`);
  };
  const addQueryParam = (paramName: string, value: string) => {
    setQueryParams({ ...queryParams, [paramName]: value });
  };
  const appendQueryParams = (newParams: Partial<T>) => {
    setQueryParams({ ...queryParams, ...newParams });
  };
  const removeQueryParam = (paramName: string) => {
    setQueryParams(omit(queryParams, paramName));
  };
  return {
    params: queryParams,
    setQueryParams,
    addQueryParam,
    removeQueryParam,
    appendQueryParams,
  };
};
